import { Component, OnInit, NgZone } from '@angular/core';
import { Select2OptionData, Select2TemplateFunction } from 'ng2-select2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../../../services/auth.service';
import { Passenger } from './../../../models/passenger';
import { NgxRolesService } from 'ngx-permissions';
import { Router } from '@angular/router';
import { PNotifyService } from '../../../services/pnotify.service';
import { IMultiSelectSettings, IMultiSelectTexts, IMultiSelectOption } from 'angular-2-dropdown-multiselect';
import { Journey } from './../../../models/journey';
import * as moment from 'moment';
import { analyzeAndValidateNgModules } from '@angular/compiler';
declare const google: any;


@Component({
  selector: 'app-assignments',
  templateUrl: './assignments.component.html',
  styleUrls: ['./assignments.component.css']
})
export class AssignmentsComponent implements OnInit {

  filter = {
    clientId: '',
    schoolId: '',
    busIds: [],
  };
  staticFilter: any;
  clientsData: Array<Select2OptionData>;
  clients: any[];
  schoolsData: Array<Select2OptionData>;
  schools: any[];
  buses: any[];
  passengers: any[];
  passengersData: Array<Select2OptionData>;
  assignmentData: Array<Select2OptionData>;
  assignmentBusData: any;
  assignmentBusBox = false;
  assignmentBusId;
  busInfo;
  directionsService: any;
  directionsRenderer: any;
  adminStatus = true;
  parentSelectedId: any;
  


  // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 0,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // ----- End MultiSelect -----------
  optionsModelBus: number[];
  multiSelectBus: IMultiSelectOption[];
  isResponsible = false;
  onLoadFilter = true;
  loadData = false;
  map: any;
  markerBounds: any;
  reservedColors = [];
  pnotify = undefined;
  assignmentBusOptions: Select2Options;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {
    this.assignmentData = [
      {
        id: '0',
        text: 'CONSULTATION',
      },
      {
        id: '1',
        text: 'AFFECTATION',
      }
    ]
    this.initClientSelect();
    this.pnotify = pnotifyService.getPNotify();
  }
  ngOnInit() {
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.adminStatus = this.authService.getUser().isRespAdmin;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        this.clientsData = this.clients.map(function (client, index) {
          return { id: client.id, text: client.name };
        });
      });
    }
    this.staticFilter = this.filter;
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      this.schoolsData = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
    });
  }

  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  parentsChanged(e: any) {
    this.parentSelectedId = e.value;
    console.log("parentSelectedId :" + this.parentSelectedId);
  }

  initBusSelect() {
    this.filter.busIds = [];
    this.optionsModelBus = [];
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId,
        all: 'true'
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      // attention: last bus is "Neutre"
      this.buses = buses;
      this.multiSelectBus = this.buses;
      this.initReservedColors(buses.length - 1);
      if (this.multiSelectBus.length) {
        for (let i = 0; i < this.multiSelectBus.length; i++) {
          this.optionsModelBus.push(this.multiSelectBus[i].id);
          this.filter.busIds.push(this.multiSelectBus[i].id);
        }
      }
      if (this.onLoadFilter) {
        this.onFilter();
        this.onLoadFilter = false;
      }
    });
  }

  onBusChange() {
    this.fillPassenger();
  }

  initMap() {
    var center = { lat: 33.906203, lng: -6.9299658 };
    var schoolName = '';
    for (var i = 0; i < this.schools.length; i++) {
      if (this.filter.schoolId == this.schools[i].id) {
        center = { lat: parseFloat(this.schools[i].lat), lng: parseFloat(this.schools[i].lng) };
        schoolName = this.schools[i].name;
        break;
      }
    }
    // map
    this.map = new google.maps.Map(document.getElementById('assignment-map'), {
      zoom: 10,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControl: true,
      streetViewControl: false,
      zoomControl: true,
      zoomControlOptions: {
        position: google.maps.ControlPosition.RIGHT_TOP,
      },
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR, // Or DROPDOWN_MENU
        position: google.maps.ControlPosition.RIGHT_BOTTOM // Change the position here
      }
      // draggableCursor: 'url(assets/images/markers/bucket.png), crosshair'
    });
    this.markerBounds = new google.maps.LatLngBounds();
    // school marker
    const schoolInfowindow = new google.maps.InfoWindow({
      content: '<b>École : </b>' + schoolName
    });
    const schoolMarker = new google.maps.Marker({
      position: center,
      map: this.map,
      icon: 'assets/images/markers/school.png',
      // zIndex: 99
    });
    this.markerBounds.extend(center);
    schoolMarker.addListener('mouseover', function () {
      // this.map.setOptions({ draggableCursor: 'url(assets/images/markers/bucket.png), crosshair' });
      schoolInfowindow.open(this.map, schoolMarker);
    });
    schoolMarker.addListener('mouseout', function () {
      schoolInfowindow.close();
    });
  }

  fillPassenger() {
    const params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId + '',
        busIds: JSON.stringify(this.optionsModelBus),
        //journeyIds: JSON.stringify(this.optionsModelJourney),
        isPositionValide: 'true',
        //isAssistant: 'false',
        isActive: 'true',
      }
    });

    this.http.get('/api/passenger/lookup2', { params })
      .subscribe(
        (passengers: any) => {
          this.passengersData = passengers.rows.map((passenger, index) => {
            return { id: passenger.id, text: passenger.lastname };
          });
          if (this.onLoadFilter) {
            this.onFilter();
            this.onLoadFilter = false;
          }
          this.loadData = false;
        }
      );
  }

  onFilter() {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    this.loadData = true;
    this.initMap();

    if (this.filter.schoolId != '' && this.filter.schoolId != '' && this.filter.busIds.length > 0) {
      const params = new HttpParams({
        fromObject: {
          schoolId: this.filter.schoolId + '',
          busIds: JSON.stringify(this.optionsModelBus),
        }
      });
      this.getDataFilter(params);
    }

    this.assignmentBusData = this.buses.map((bus, index) => {
      return {
        id: bus.id,
        text: bus.name,
        //color: (bus.id != 0) ? this.getReservedColor(index) : '#000',
        color: (bus.id != 0) ? bus.colorLineBus : '#000',
        bus: bus
      };
    });
    console.error('assignmentBusData', this.assignmentBusData);
    this.assignmentBusOptions = {
      templateResult: this.templateResult,
      // templateSelection: this.templateSelection
    };
  }
  getDataFilter(params) {

    this.http.get('/api/planificationAndOptimization/assignments', { params })
      .subscribe(
        (data: any) => {
          this.loadData = false;
          this.passengers = data.passengers;
          // fitch date to get bus
          for (let index = 0; index < this.assignmentBusData.length; index++) {
            const passengers = this.passengers.filter(this.getDataFromBus(this.assignmentBusData[index].id));
            //  Create Passengers
            this.createPassengers(
              this.assignmentBusData[index].bus,
              passengers,
              this.map,
              this.assignmentBusData[index].color
            );
          }
          this.map.fitBounds(this.markerBounds);
        },
        error => {
          this.loadData = false;
        }
      );
  }

  getDataFromBus(id) {
    return function (element) {
      return (element.busId != null) ? element.busId === id : element.busId === null;
    };
  }

  createPassengers(bus, passengers, map, color) {
    const infowindow = new google.maps.InfoWindow();
    const markers = [];
    for (let i = 0; i < passengers.length; i++) {
      if (passengers[i].isPositionValide) {
        const pos = new google.maps.LatLng(passengers[i].lat, passengers[i].lng)
        const marker = new google.maps.Marker({
          position: pos,
          map: map,
          icon: {
            path: (passengers[i].isAssistant) ? 'M -1,-1 1,-1 1,1 -1,1 z' : google.maps.SymbolPath.CIRCLE,
            scale: 8,
            fillColor: color,
            fillOpacity: 1,
            strokeWeight: 2,
            strokeColor: (passengers[i].isAssistant) ? color : '#fff',
          },
          passengerId: passengers[i].id,
          schoolId: this.staticFilter.schoolId,
        });
        markers.push(marker);
        this.markerBounds.extend(pos);

        const _this = this;
        google.maps.event.addListener(marker, 'click', ((marker, i) => {
          return function () {
            if (_this.assignmentBusBox) {
              _this.assignment(passengers[i], bus, map, marker);
            } else {
              _this.getNotification(passengers[i], bus, map, marker, infowindow, false);
            }
          };
        })(marker, i));

        google.maps.event.addListener(marker, 'mouseover', ((marker, i) => {
          return function () {
            if (_this.assignmentBusBox) {
              _this.getNotification(passengers[i], bus, map, marker, infowindow, true);
            }
          };
        })(marker, i));

        google.maps.event.addListener(marker, 'mouseout', ((marker, i) => {
          return function () {
            if (_this.assignmentBusBox) {
              infowindow.close();
            }
          };
        })(marker, i));

        if (this.parentSelectedId+"" === passengers[i].id+"" ){
          _this.getNotification(passengers[i], bus, map, markers[i], infowindow, false);
        }
      
      }
    }
  }

  getNotification(passenger, bus, map, marker, infowindow, assignmentstat) {

    var content;

    if (assignmentstat) {
       content = `<b>CLICK POUR AFFECTER CE(S) PASSAGER(S)</b> <br />
        <b>Nom : </b>${passenger.lastname}<br />
        <b>Prénom(s) : </b>${passenger.firstnames}<br />
        <b>Nombre de passager : </b>${passenger.count}<br />
        <b>Bus : </b>${bus ? bus.name : '--'}<br />
        <b>Abonnement : </b>${passenger.subscription}<br />
        <b>Cood. GPS : </b>${passenger.lat} , ${passenger.lng}<br />`;
    } else {
       content = `<b>Nom : </b>${passenger.lastname}<br />
        <b>Prénom(s) : </b>${passenger.firstnames}<br />
        <b>Nombre de passager : </b>${passenger.count}<br />
        <b>Bus : </b>${bus ? bus.name : '--'}<br />
        <b>Abonnement : </b>${passenger.subscription}<br />
        <b>Cood. GPS : </b>${passenger.lat} , ${passenger.lng}<br />`;
    }
    infowindow.setContent(content);
    infowindow.open(map, marker);
  }

  hue2rgb(p, q, t) {
    if (t < 0) { t += 1; }
    if (t > 1) { t -= 1; }
    if (t < 1 / 6) { return p + (q - p) * 6 * t; }
    if (t < 1 / 2) { return q; }
    if (t < 2 / 3) { return p + (q - p) * (2 / 3 - t) * 6; }
    return p;
  }

  hslToRgb(h, s, l) {
    let r, g, b;

    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = this.hue2rgb(p, q, h + 1 / 3);
      g = this.hue2rgb(p, q, h);
      b = this.hue2rgb(p, q, h - 1 / 3);
    }

    return [Math.round(r * 200) + 25, Math.round(g * 200) + 25, Math.round(b * 200) + 25];
  }

  generateColor() {

    while (true) {
      const color = [
        Math.floor(Math.random() * 256),
        Math.floor(Math.random() * 256),
        Math.floor(Math.random() * 256)
      ];
      let isAvailable = true;
      for (let i = 0; i < this.reservedColors.length; i++) {
        let deltaBlack = color[0] + color[1] + color[2];
        let deltaWhite = 255 * 3 - deltaBlack;
        let deltaRed = color[0] - this.reservedColors[i][0];
        let deltaGreen = color[1] - this.reservedColors[i][1];
        let deltaBlue = color[2] - this.reservedColors[i][2];
        let delta = Math.abs(deltaRed) + Math.abs(deltaGreen) + Math.abs(deltaBlue);
        if (Math.sign(deltaRed) === Math.sign(deltaGreen) &&
          Math.sign(deltaRed) !== Math.sign(deltaBlue)) {
          delta += Math.abs(deltaBlue);
        } else if (Math.sign(deltaRed) === Math.sign(deltaBlue) &&
          Math.sign(deltaRed) !== Math.sign(deltaGreen)) {
          delta += Math.abs(deltaGreen);
        } else if (Math.sign(deltaGreen) === Math.sign(deltaBlue) &&
          Math.sign(deltaRed) !== Math.sign(deltaGreen)) {
          delta += Math.abs(deltaRed);
        }
        if (deltaBlack < 250 || deltaWhite < 60 || delta < 100) {
          isAvailable = false;
          break;
        }
      }
      if (isAvailable === true) {
        return color;
      }
    }
  }

  initReservedColors(length) {
    this.reservedColors = [];

    for (let i = 1; i <= length; i++) {
      // this.reservedColors.push(this.hslToRgb(i / length, 0.5, 0.5));
      this.reservedColors.push(this.generateColor());
    }
    // this.reservedColors.push([255, 255, 255]);
    // this.reservedColors.push([0, 0, 0]);

    console.error('reservedColors', this.reservedColors);

    return;
  }

  getReservedColor(index) {
    const color = this.reservedColors[index];
    const hexColor = '#' + color[0].toString(16).padStart(2, '0').toUpperCase()
      + color[1].toString(16).padStart(2, '0').toUpperCase()
      + color[2].toString(16).padStart(2, '0').toUpperCase();

    console.error('index', index, 'color', color, 'hexColor', hexColor);

    return hexColor;
  }

  assignmentChanged(e: any) {
    this.assignmentBusBox = (e.value == 1) ? true : false;
    this.assignmentBusId = this.assignmentBusData[0].bus.id;
    this.busInfo = this.assignmentBusData[0];
    if (e.value != 1) {
      this.map.setOptions({ draggableCursor: null });
    } else {
      this.map.setOptions({ draggableCursor: 'url(assets/images/markers/bucket.png), crosshair' });
    }
  }
  assignmentBusChanged(e: any) {
    this.assignmentBusId = e.value;
    const bus = this.assignmentBusData.filter((element) => {
      return element.bus.id == e.value;
    });
    this.busInfo = bus.shift();
  }

  assignment(passenger, bus, map, marker) {
    if (bus.id != this.assignmentBusId) {
      this.pnotify.notice({
        title: 'Confirmation',
        text: 'Le changement de bus entraine la désinscription de tous ses trajets. Voules-vous continuer ?',
        stack: {
          firstpos1: 70, firstpos2: 10,
          modal: true,
          overlay_close: true
        },
        hide: false,
        modules: {
          Confirm: {
            confirm: true,
            buttons: [
              {
                text: 'Ok',
                addClass: 'btn btn-chico',
                click: notice => {
                  notice.close();
                  this.http.put(
                    '/api/passenger/assign/' + passenger.id + '/' + this.assignmentBusId,
                    {}
                  ).subscribe(
                    (resp: any) => {
                      passenger = resp.AffectedPassenger;
                      marker.setMap(null);
                      const oldBus = this.assignmentBusData.filter((element) => {
                        return element.id === Number(bus.id);
                      }).shift();
                      oldBus.bus.totalPassengersCount -= passenger.count;
                      const newBus = this.assignmentBusData.filter((element) => {
                        return element.id === Number(this.assignmentBusId);
                      }).shift();
                      newBus.bus.totalPassengersCount += passenger.count;
                      passenger.busId = newBus.id;
                      this.createPassengers(newBus.bus, [passenger], this.map, newBus.color);
                      this.updateAffectedjourneys(resp.AffectedJourneyIds);
                    },
                    (error) => {
                      this.pnotify.error({
                        title: 'Erreur',
                        text: 'Une erreur est survenue !',
                        stack: {
                          firstpos1: 70, firstpos2: 10,
                          modal: true,
                          overlay_close: true
                        },
                        hide: false,
                        modules: {
                          Confirm: {
                            confirm: true,
                            buttons: [
                              {
                                text: 'Ok',
                                addClass: 'btn btn-chico',
                                click: _notice => {
                                  _notice.close();
                                }
                              }
                            ]
                          }
                        }
                      });
                    }
                  );
                }
              },
              {
                text: 'Annuler',
                addClass: 'btn btn-default',
                click: (notice) => {
                  notice.close();
                  notice.fire('pnotify.cancel', { notice });
                }
              }
            ]
          }
        }
      });
    }
  }

  updateAffectedjourneys(AffectedJourneyIds: any) {
    let journey: any;
    let results: any;

    for (let i = 0; i < AffectedJourneyIds.length; i++) {
      this.http.get(
        '/api/journey/findOne/' + AffectedJourneyIds[i]
      ).subscribe((_journey: Journey) => {
        journey = _journey;

        results = this.calculateNewRoute(journey);
      });
    }
  }

  calculateNewRoute(_journey: Journey) {
    const journey: Journey = _journey;
    this.directionsService = new google.maps.DirectionsService;
    this.directionsRenderer = new google.maps.DirectionsRenderer({ suppressMarkers: true });
    const waypts = [];
    let PositionPassager: any;

    journey.start = new Date(Number(_journey.start) * 1000);
    journey.JourneyPassengers.forEach((JourneyPassenger) => {
      PositionPassager = new google.maps.LatLng(Number(JourneyPassenger.Passenger.lat), Number(JourneyPassenger.Passenger.lng));
      waypts.push({
        location: PositionPassager,
        stopover: true
      });
    });

    this.directionsService.route({
      origin: { lat: Number(journey.startPositionLat), lng: Number(journey.startPositionLng) },
      destination: { lat: Number(journey.endPositionLat), lng: Number(journey.endPositionLng) },
      waypoints: waypts,
      optimizeWaypoints: true,
      travelMode: 'DRIVING'
    }, (response, status) => {
      let distancetrajet: any = 0;
      let TimeEstimatedPassager: any = this.getElapsedSecondsInDay(journey.start);
      if (journey.type === ('M1' || 'AM1')) {
        journey.waitTimePassager = 25;
      } else {
        journey.waitTimePassager = 0;
      }
      if (status === 'OK') {
        // this.directionsRenderer.setDirections(response);
        // Calcule: Temps estimé de fin de trajet / Arrivé a chaque arret / distance total estimé
        if (waypts.length > 0) {
          const route = response.routes[0];
          // 1- Ajouter la distance et la durée du point depart au premier passager
          distancetrajet = distancetrajet + route.legs[0].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[0].duration.value;
          journey.JourneyPassengers[0].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          // 2- Ajouter la distance et la durée pour chaque point d'arret
          for (let i = 1; i <= route.legs.length - 2; i++) {
            distancetrajet = distancetrajet + route.legs[i].distance.value;
            TimeEstimatedPassager = TimeEstimatedPassager + route.legs[i].duration.value + journey.waitTimePassager;
            journey.JourneyPassengers[i].estimatedTime = new Date(Number(TimeEstimatedPassager) * 1000);
          }
          // 3- Ajouter la distance et la durée pour aller au point destinations
          distancetrajet = distancetrajet + route.legs[route.legs.length - 1].distance.value;
          TimeEstimatedPassager = TimeEstimatedPassager + route.legs[route.legs.length - 1].duration.value;

          journey.distance = Number((distancetrajet / 1000).toFixed(0));
          journey.end = new Date(Number(TimeEstimatedPassager) * 1000);

        }
        journey.start = this.getElapsedSecondsInDay(journey.start);
        journey.end = this.getElapsedSecondsInDay(journey.end);
        journey.JourneyPassengers.forEach((journeyPassenger, index) => {
          journey.JourneyPassengers[index].estimatedTime = this.getElapsedSecondsInDay(journeyPassenger.estimatedTime);
          journeyPassenger.order = index + 1;
        });
        // Update server
        this.http.put(
          '/api/journey/' + journey.id,
          { journey: journey }
        ).subscribe(() => {},
          (error) => {
            this.pnotify.error({
              title: 'Erreur',
              text: 'Une erreur est survenue !',
              stack: {
                firstpos1: 70, firstpos2: 10,
                modal: true,
                overlay_close: true
              },
              hide: false,
              modules: {
                Confirm: {
                  confirm: true,
                  buttons: [
                    {
                      text: 'Ok',
                      addClass: 'btn btn-chico',
                      click: notice => {
                        notice.close();
                      }
                    }
                  ]
                }
              }
            });
          }
        );
      } else {
        console.log ('Directions request failed due to ' + status);
      }
    });
  }

  getElapsedSecondsInDay(date) {
    const day = moment(date);
    const startOfDay = day.clone().startOf('day');
    return day.diff(startOfDay, 'seconds');
  }

  public templateResult: Select2TemplateFunction = (state: any): JQuery | string => {
    let content = `<span> <i class="select2Circle" style="background-color:${state.color}"></i> ${state.text}</span>`;
    return jQuery(content);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/planning-and-optimization/assignments/assignments.component.ts